var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "nav",
    {
      style: { background: "#fff", "font-weight": 700 },
      attrs: { id: "sidebar", "aria-label": "Main Navigation" },
    },
    [
      _vm._t("default", function () {
        return [
          _c(
            "div",
            {
              staticClass:
                "omc-header d-flex align-items-center justify-content-between",
              staticStyle: {
                background: "#fff",
                height: "80px",
                padding: "1em !important",
              },
            },
            [
              _c("router-link", {
                staticClass: "mr-3 sidebar_logo",
                attrs: { to: { name: "Main" }, variant: "Main_Logo" },
              }),
              _c(
                "base-layout-modifier",
                {
                  staticClass: "p-0",
                  attrs: { variant: "alt-none", action: "sidebarClose" },
                },
                [_c("b-icon", { attrs: { icon: "x", scale: "2" } })],
                1
              ),
            ],
            1
          ),
          _c(
            "simplebar",
            { staticClass: "js-sidebar-scroll" },
            [
              _c("Menu", {
                staticClass: "side-bar",
                attrs: { "side-bar": "" },
              }),
            ],
            1
          ),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }